import React, { useState } from "react";
import Modal from "@visiblethread/react-components/dist/components/Modal";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import Radio from "@visiblethread/react-components/dist/components/Radio";
import { exportAnnotatedDocument } from "slices/dictionarySearch/actions/dictionarySearch";
import PropTypes from "prop-types";

const AnnotatedDocumentModal = ({ selectedTerms }) => {
  const dispatch = useDispatch();
  const options = [
    {
      text: "Use 'VisibleThread' as the comment author (default)",
      disabled: false,
    },
    {
      text: "Use the dictionary category as the comment author",
      disabled: false,
    },
  ];
  const [selectedOption, setSelectedOption] = useState(options[0].text);
  const handleSubmit = () => {
    dispatch(
      exportAnnotatedDocument(selectedTerms, selectedOption === options[1].text)
    );
    dispatch(hideModal(modalTypes.ANNOTATED_DOCUMENT));
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.ANNOTATED_DOCUMENT));
  };

  const modalBody = () => (
    <div className="annotated_document__body">
      Annotated Document Settings:
      <Radio
        options={options}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
      />
    </div>
  );

  return (
    <Modal
      data-test="annotatedDocumentModal"
      className="fade-in"
      show
      backdrop="static"
      centered
      onDismiss={handleCancel}
    >
      <Modal.Header closeButton>
        <b className="annotated_document__header">
          Download Annotated Document
        </b>
      </Modal.Header>
      <Modal.Body>{modalBody()}</Modal.Body>
      <Modal.Footer>
        <Button
          dataTestId="generate-document-button"
          variant={buttonVariants.primary}
          onClick={handleSubmit}
          content="Generate Document"
        />
        <Button
          dataTestId="cancel-button"
          variant={buttonVariants.secondary}
          onClick={handleCancel}
          content="Cancel"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default AnnotatedDocumentModal;

AnnotatedDocumentModal.propTypes = {
  selectedTerms: PropTypes.arrayOf(PropTypes.string),
};
